import axios from 'axios'
import router from './router'
import {Toast} from "vant";
import i18n, {backGetLang} from "@/lang";


const instance = axios.create()
// 在实例已创建后修改默认值
instance.interceptors.request.use(function (config) {

  config.headers.token = localStorage.getItem('token')
  config.headers['Accept-Language'] = backGetLang()
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  if (response.data === "" && response.request.responseText != null) {
    try {
      response.data = JSON.parse(response.request.response);
    } catch (e) {
      console.log(e);
    }
  }
  if (response.data.code === 401 || response.status === 302 || response.status === 502) {
    Toast(i18n.t('append_field.expired_login'),'fail')
    // 获取需要保留的数据
    const user = localStorage.getItem("userName")||"";
    const pwd = localStorage.getItem("userPwss")||"";
    const rememberMe = localStorage.getItem("rememberMe")||"";
    // 清除所有本地存储数据
    localStorage.clear()
    // 将需要保留的数据重新存储
    localStorage.setItem("userName", user);
    localStorage.setItem("userPwss", pwd);
    localStorage.setItem("rememberMe", rememberMe);
    router.push('/login')
  }


  return response
}, function (error) {
  return Promise.reject(error)
})

export default instance
